export const getters = {
  getterCount(state) {
    return (state.count += 2);
  },
  getUserInfo(state) {
    return state.userInfos;
  },
  getAuthInfo(state) {
    return state.authInfos;
  },
  getCtrlInfo(state) {
    return state.strictCtrlInfo;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/getters.js